// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../css/Theme.bs.js";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "@prezzee/ribbon/src/theme/Theme__Responsive.bs.js";

var container = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1440)),
      tl: {
        hd: BsCss.marginLeft("auto"),
        tl: {
          hd: BsCss.marginRight("auto"),
          tl: {
            hd: BsCss.paddingLeft(BsCss.px(30)),
            tl: {
              hd: BsCss.paddingRight(BsCss.px(30)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var rootContainer = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: /* [] */0
    });

var bottomContainer = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.lilac300),
      tl: {
        hd: BsCss.padding2(BsCss.px(40), "zero"),
        tl: /* [] */0
      }
    });

var bottomContainerSection = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.maxWidth(BsCss.px(1440))),
      tl: {
        hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.tabletSm, {
              hd: BsCss.important(BsCss.paddingLeft(BsCss.rem(1.25))),
              tl: {
                hd: BsCss.important(BsCss.paddingRight(BsCss.rem(1.25))),
                tl: /* [] */0
              }
            }),
        tl: {
          hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.tabletSmOrTablet, {
                hd: BsCss.important(BsCss.paddingLeft(BsCss.rem(2))),
                tl: {
                  hd: BsCss.important(BsCss.paddingRight(BsCss.rem(2))),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var bottomInnerContainer = Curry._1(BsCss.style, {
      hd: BsCss.padding2(BsCss.rem(1.5), BsCss.rem(1)),
      tl: {
        hd: BsCss.backgroundColor(Theme.Color.white),
        tl: {
          hd: BsCss.borderRadius(BsCss.px(4)),
          tl: {
            hd: BsCss.boxShadow(Css_Legacy_Core.Shadow.box(BsCss.px(0), BsCss.px(6), BsCss.px(12), undefined, undefined, BsCss.rgba(0, 0, 0, BsCss.pct(11.0)))),
            tl: {
              hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, {
                    hd: BsCss.padding(BsCss.rem(2.625)),
                    tl: /* [] */0
                  }),
              tl: {
                hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.desktop, {
                      hd: BsCss.display("flex"),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: BsCss.selector("&>*:not(:first-child)", {
                        hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, {
                              hd: BsCss.borderTop(BsCss.px(1), "solid", Theme.Color.gray300),
                              tl: /* [] */0
                            }),
                        tl: {
                          hd: BsCss.media(Theme__Responsive$PrezzeeRibbon.desktop, {
                                hd: BsCss.borderLeft(BsCss.px(1), "solid", Theme.Color.gray300),
                                tl: /* [] */0
                              }),
                          tl: /* [] */0
                        }
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  rootContainer: rootContainer,
  bottomContainer: bottomContainer,
  bottomContainerSection: bottomContainerSection,
  bottomInnerContainer: bottomInnerContainer
};

export {
  Styles ,
}
/* container Not a pure module */
